angular.module('smartorg.r6.acts.universal.schema', [
    require('../../../../../../../../components/list-selector/app/js/plumbing/app'),
    require('../../../../../../../../components/table-selector/app/js/plumbing/app')
]);
require('./schema-builder-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.acts.universal.schema';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/universal-io/app/schema-builder/app/js/plumbing/app.js